module.exports = __webpack_public_path__ + "img/location.c2314b63.svg";